<template>
  <vx-card
    class="w-full mb-5"
    :title="$t('class-overview.class-material')" title-color="primary"
  >
    <li class="flex flex-inline justify-between w-full">
      <div class="flex-1 w-2/5">
        <vs-chip class="cursor-pointer w-3/5" color="primary" transparent>
          <span>{{$t('class-overview.class-material-list')}}</span>
        </vs-chip>
      </div>
      <div class="w-2/5">
      </div>
    </li>
    <li
      v-for="(material, index) in classMaterials" :key="material.id + '_' + index"
      class="w-full pl-0" style="list-style: none;"
    >
      <div class="flex justify-between items-center w-full px-3 pl-0">
        <div class="flex-1 flex justify-start items-start">
          <vs-avatar :text="`${index + 1}`" class="bg-primary w-5 h-5 text-sm mr-2 p-2"/>
          <span class="text-sm mt-1">
                  {{ material.nameLocal }}
                </span>
        </div>
        <div class="flex w-2/5 justify-end mr-0">
          <!--VIDEO-->
          <vs-chip v-if="isVideoType(material)"
            :color="material.uploadPathUri ? 'primary' : 'lightgrey' "
            :disabled="!material.uploadPathUri"
            class="cursor-pointer w-auto pl-1 pr-4 h-4"
            @click.native="handlerPlay(material)">
            <vs-avatar
              class="h-5 w-5" color="primary" icon="icon-play" icon-pack="feather"/>
            <span class="text-sm">{{ $t("general.preview-video") }}</span>
          </vs-chip>

          <!--DOCUMENT-->
          <vs-chip v-else-if="material.uploadPathUri"
                   :color="material.uploadPathUri ? 'primary' : 'lightgrey' "
                   :disabled="!material.uploadPathUri"
                   class="cursor-pointer w-auto pl-1 pr-4 h-4"
                   @click.native="handlerDownload(material.uploadPathUri)">
            <vs-avatar
              class="h-5 w-5" color="primary" icon="icon-download" icon-pack="feather"/>
            <span class="text-sm">{{ $t("general.download") }}</span>
          </vs-chip>
        </div>
      </div>
    </li>

    <vs-prompt
               :active.sync="activePrompt"
               :title="videoPreview.title"
               :buttons-hidden="true"
               @cancel="closePreviewVideo"
               @close="closePreviewVideo"
               class="preview-video">

      <preview-video-card :current-vdo-set-topic="videoPreview"></preview-video-card>
    </vs-prompt>

  </vx-card>
</template>

<script>
import PreviewVideoCard from "@/views/pages/E-Learning/ClassOverview/Components/PreviewVideoCard";
import {config} from '@/utils/upload'

export default {
  name: "ClassMaterial",
  props: ['classMaterials'],
  components:{
    PreviewVideoCard
  },
  data(){
    return {
      e_code: !localStorage.getItem("rsc") ? null : JSON.parse(localStorage.getItem("rsc")).e_code,
      r_stage: !localStorage.getItem("rsc") ? null : JSON.parse(localStorage.getItem("rsc")).r_stage,
      //for preview video
      activePrompt: false,
      videoPreview: {},
    }
  },
  methods:{
    handlerDownload(fileUUID) {
      // const url = config.url.downloadFile + fileUUID;
      if(fileUUID){
        const url = `${config.url.downloadFile}${this.e_code}/${this.r_stage}/${fileUUID}`;
        window.open(url, '_blank');
      }
    },
    handlerPlay(item) {
      this.activePrompt = true;
      this.videoPreview = {
        title: item.nameLocal,
        vdoStreamPath: `${item.uploadPath}/${item.uploadPathUri}`
      };
    },
    closePreviewVideo() {
      this.activePrompt = false;
      this.videoPreview = {};
    },
    isVideoType(item) {
      return item.uploadFileName.includes('.mp4');
    }
  }
}
</script>

<style scoped>

</style>
